import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      connectMap: {
        ...store.getState().i18n.translations.en.connectMap,
        main: {
          ENTITY_MAP: 'Entity map',
          INTERCONNECTION_MAP: 'Interconnection map',
          EXPLORE_CONNECTMAP_FEATURES: 'Explore ConnectMap Features',
          EXPLORE_CONNECTMAP_FEATURES_DEPS_1:
            'Your account is not currently subscribed to the ConnectMap service.',
          EXPLORE_CONNECTMAP_FEATURES_DEPS_2:
            'Purchase the ConnectMap service to uncover hidden connections and gain valuable insights.',
          NOT_NOW: 'Not now',
          VIEW_INFO: 'View  pricing plan',
          NODATA_ADD_COMPANY:
            'No items match your search or this company has already existed in this list.',
          LEAST2: 'Insert at least 2 letters',
          PLEASE_SELECT_VALIDATION: 'Please select between 2 and 10 entities.',
          SEARCH_COMPANY: 'Enter company name, tax code or ticker',
          SEARCH_PERSON_NAME: 'Enter person name',
          FILTER_BY_COMPANY: 'Filter by company',
          INDIVIDUAL: 'Individual',
          COMPANIES_WITH_OWNERSHIP: 'Companies with Ownership',
          COMPANIES_WITH_EXECUTIVE_ROLES: 'Companies with Executive Roles',
          UPGRADE_WITH_CONNECTMAP: 'Upgrade with ConnectMap',
          DESCRIPTION_UPGRADE_CONNECT_MAP:
            'Purchase the ConnectMap service to uncover hidden connections and gain valuable insights.<br/>After your request, our customer success team will contact you to arrange a demo and complete the setup on your account.',
          SEND_REQUEST: 'Send Request',
          CANCEL: 'Cancel',
          FULL_NAME: 'Full name',
          EMAIL: 'Email',
          INVALID_EMAIL:
            'Invalid email address. Please enter the correct email',
          REQUIRED_FIELD: 'This is a required field!',
          INVALID_PHONE:
            'Invalid phone number. Please enter the correct number',
          PHONE_NUMBER: 'Phone number',
          GET_CONNECT_MAP: 'Get ConnectMap',
          NODATA_SEARCH: 'No items match your search.',
        },
        entityMap: {
          COMPANY: 'Company',
          PERSON: 'Person',
          RADIAL_MAP: 'Radial map',
          LEGAL_BENEFICIAL: 'Legal Beneficial Ownership Map',
          INVESTEE_MAP: 'Investee Map',
          DEGREE_1: 'Degree 1',
          DEGREE_2: 'Degree 2',
          PLEASE_SELECT:
            'Search for a company or individual to explore their connections.',
          PLEASE_SELECT_WARNING:
            'The Legal Beneficial Ownership Map is only available for companies. Please select a company to view this map.',
        },
        interconnectionMap: {
          COMPANY: 'Company',
          PERSON: 'Person',
          FILTER_BY_COMPANY: 'Filter by company',
          RADIAL_MAP: 'Radial map',
          LEGAL_BENEFICIAL: 'Legal Beneficial Ownership Map',
          INVESTEE_MAP: 'Investee Map',
          DEGREE_1: 'Degree 1',
          DEGREE_2: 'Degree 2',
          DEGREE_3: 'Degree 3',
          VIEW: 'View',
          PLEASE_SELECT:
            'Select 2–10 companies and/or individuals to explore their network of connections.',
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      connectMap: {
        ...store.getState().i18n.translations.vi.connectMap,
        main: {
          ENTITY_MAP: 'Bản đồ thực thể riêng lẻ',
          INTERCONNECTION_MAP: 'Bản đồ liên kết đa chiều',
          EXPLORE_CONNECTMAP_FEATURES: 'Khám phá tính năng ConnectMap',
          EXPLORE_CONNECTMAP_FEATURES_DEPS_1:
            'Tài khoản của bạn hiện chưa đăng ký dịch vụ ConnectMap.',
          EXPLORE_CONNECTMAP_FEATURES_DEPS_2:
            'Đăng ký dịch vụ ConnectMap để làm sáng tỏ các kết nối tiềm ẩn và tiếp cận những thông tin chuyên sâu hữu ích.',
          NOT_NOW: 'Để sau',
          VIEW_INFO: 'Xem chính sách giá',
          NODATA_ADD_COMPANY:
            'Không có kết quả phù hợp hoặc đối tượng này hiện đã tồn tại trong danh sách.',
          LEAST2: 'Nhập ít nhất 2 ký tự',
          PLEASE_SELECT_VALIDATION: 'Vui lòng chọn từ 2 đến 10 đối tượng.',
          SEARCH_COMPANY: 'Nhập tên công ty, mã số thuế hoặc mã chứng khoán',
          SEARCH_PERSON_NAME: 'Nhập tên cá nhân',
          FILTER_BY_COMPANY: 'Lọc theo công ty liên quan',
          INDIVIDUAL: 'Tên cá nhân',
          COMPANIES_WITH_OWNERSHIP: 'Công ty sở hữu',
          COMPANIES_WITH_EXECUTIVE_ROLES: 'Công ty quản lý điều hành',
          UPGRADE_WITH_CONNECTMAP: 'Mở rộng tính năng với ConnectMap',
          DESCRIPTION_UPGRADE_CONNECT_MAP:
            'Đăng ký dịch vụ ConnectMap để làm sáng tỏ các kết nối tiềm ẩn và tiếp cận những thông tin chuyên sâu hữu ích. <br/> Sau khi nhận yêu cầu, đội ngũ chăm sóc khách hàng sẽ liên hệ để demo và cài đặt dịch vụ trên tài khoản của bạn.',
          SEND_REQUEST: 'Gửi yêu cầu',
          CANCEL: 'Hủy',
          FULL_NAME: 'Tên đầy đủ',
          EMAIL: 'Email',
          INVALID_EMAIL:
            'Email không hợp lệ. Vui lòng nhập địa chỉ email chính xác',
          REQUIRED_FIELD: 'Đây là 1 trường bắt buộc!',
          INVALID_PHONE:
            'Số điện thoại không hợp lệ. Vui lòng nhập số điện thoại chính xác',
          PHONE_NUMBER: 'Số điện thoại',
          GET_CONNECT_MAP: 'Kích hoạt Bản đồ kết nối',
          NODATA_SEARCH: 'Không có kết quả phù hợp.',
        },
        entityMap: {
          COMPANY: 'Công ty',
          PERSON: 'Cá nhân',
          RADIAL_MAP: 'Sơ đồ quan hệ tỏa tròn',
          LEGAL_BENEFICIAL: 'Sơ đồ quan hệ sở hữu',
          INVESTEE_MAP: 'Sơ đồ công ty được đầu tư',
          DEGREE_1: 'Degree 1',
          DEGREE_2: 'Degree 2',
          PLEASE_SELECT:
            'Tìm công ty hoặc cá nhân để xem mạng lưới quan hệ liên quan.',
          PLEASE_SELECT_WARNING:
            'Sơ đồ quan hệ sở hữu chỉ áp dụng cho công ty. Vui lòng chọn một công ty để xem bản đồ này.',
        },
        interconnectionMap: {
          COMPANY: 'Công ty',
          PERSON: 'Cá nhân',
          RADIAL_MAP: 'Sơ đồ quan hệ tỏa tròn',
          LEGAL_BENEFICIAL: 'Sơ đồ quan hệ sở hữu',
          INVESTEE_MAP: 'Sơ đồ công ty được đầu tư',
          DEGREE_1: 'Degree 1',
          DEGREE_2: 'Degree 2',
          DEGREE_3: 'Degree 3',
          VIEW: 'Xem quan hệ',
          PLEASE_SELECT:
            'Chọn từ 2–10 công ty và/hoặc cá nhân để khám phá mạng lưới quan hệ.',
        },
      },
    },
  }),
)
